@if (flights(); as flights) {
  @for (flight of flights; track $index; let i = $index; let first = $first; let last = $last) {
    <div class="flex flex--space-between flex--middle ms-xsmall-b">
      <h2 class="font-body-medium" [class.ms-xsmall-y]="i < 2">
        {{ 'bookingSearch.boundSelection.flightTitle' | finLocalization: { index: i + 1 } }}
      </h2>
      @if (i >= 2) {
        <fcom-icon-button
          class="flex flex--center flex--self-center location-switch"
          [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE }"
          [theme]="IconButtonTheme.TERTIARY_GHOST"
          [size]="IconButtonSize.MEDIUM"
          [aria]="{ label: 'bookingSearch.boundSelection.removeFlight' | finLocalization: { index: i + 1 } }"
          (clickBtn)="removeFlight(i)"
          data-testid="remove-flight-button"
        />
      }
    </div>
    <div class="grid-col-12 no-gutters selector-grid" [class.ms-small-b]="!last">
      <fin-location-selector
        [locationPair]="flight"
        [showPreviousSearches]="true"
        [showSeparator]="true"
        [showLocateMe]="first"
        [showSuggestedDestinations]="first"
        (setLocations)="setLocations($event, i)"
        [attr.data-testid]="'booking-widget-full-multicity-location-selector-' + i"
      />
      <fin-travel-dates-selector
        [previousFlightDepartureDate]="flights[i - 1]?.departureDate || null"
        [travelDates]="{
          departureDate: flight.departureDate,
          returnDate: null,
        }"
        [priceCalendarType]="PriceCalendarType.ONLY_DATES"
        [locations]="{
          origin: flight.origin,
          destination: flight.destination,
        }"
        [showSingular]="'departureDate'"
        [showSeparator]="false"
        [showAddReturn]="false"
        [tripType]="TripType.ONEWAY"
        [showFlexibleDatesSelection]="false"
        [showPerAdultPrice]="false"
        (setTravelDates)="setTravelDates($event, i, false)"
        [attr.data-testid]="'booking-widget-multicity-dates-selector-' + i"
      />
    </div>
  }
  <fcom-button
    class="ms-medium-y"
    [theme]="ButtonTheme.SECONDARY_OUTLINE"
    [text]="'bookingSearch.boundSelection.addFlightButton' | finLocalization"
    [disabled]="flights.length === 6"
    (clickBtn)="addFlight(flights.length)"
    data-testid="add-flight-button"
  />
}
